import LanguageSwitcher from '../languageSwitcher'
import NotificationBellButton from '../NotificationBellButton'

const SidebarUtilityActions = ({
  variant = 'expanded',
  menuPlacement = 'top',
}) => {
  const dropdownAlign = variant === 'collapsed' ? 'outside' : 'start'
  const className =
    variant === 'collapsed'
      ? 'sidebar-utility-actions sidebar-utility-actions-collapsed sidebar-utility-actions-footer'
      : 'sidebar-utility-actions sidebar-utility-actions-footer'

  return (
    <div className={className}>
      <LanguageSwitcher
        dropdown
        compact
        ghost
        small
        iconColor="#8A8A8A"
        menuPlacement={menuPlacement}
        dropdownAlign={dropdownAlign}
      />
      <NotificationBellButton
        small
        menuPlacement={menuPlacement}
        dropdownAlign={dropdownAlign}
      />
    </div>
  )
}

export default SidebarUtilityActions
